import { render, staticRenderFns } from "./AdminProvidersTable.vue?vue&type=template&id=457de11c"
import script from "./AdminProvidersTable.vue?vue&type=script&lang=js"
export * from "./AdminProvidersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports